import { Link } from 'react-router-dom';
import { ArrowIcon, GpsIcon } from '../../../assets/icons';
import { formatMoney } from '../../../shared/utility';

const PropertyHeader = ({ name, location, unitType, unitIndex, currency }) => {
  return (
    <div className="property__header">
      <p className="property__header--location">
        <Link to="/discover">Discover</Link>
        <ArrowIcon />
        {name}
      </p>
      <div className="property__header--name">
        <div>
          <h2>{name}</h2>
          <a href={location.url} target="_blank" rel="noreferrer">
            <GpsIcon /> <span>{location.city},</span>{' '}
            <span>{location.country}</span>
          </a>
        </div>
        <p className="price">
          {!currency
            ? formatMoney(unitType[unitIndex].price)
            : formatMoney(unitType[unitIndex].price, currency)}
        </p>
      </div>
    </div>
  );
};

export default PropertyHeader;
